import React from 'react';

function FAQ() {
  return (
    <div>
      <section id="faq" class="faq section-bg">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <br />
            <h2>Frequently Asked Questions</h2>
            <p>
              At Softskart, we understand that you may have questions about our
              services. To help you, we've answered some frequently asked
              questions so you can explore how our solutions can best meet your
              needs.
            </p>
          </div>

          <div class="faq-list">
            <ul>
              <li data-aos="fade-up" data-aos-delay="100">
                {/* <i class="bx bx-help-circle icon-help"></i> */}
                <a
                  href
                  data-bs-toggle="collapse"
                  class="collapse"
                  data-bs-target="#faq-list-1"
                >
                  What makes your hosting service reliable?{' '}
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>
                <div
                  id="faq-list-1"
                  class="collapse show"
                  data-bs-parent=".faq-list"
                >
                  <p>
                    Our hosting includes 99.9% uptime, Enterprise LiteSpeed,
                    NVMe SSD storage, unlimited bandwidth, unlimited inodes,
                    unlimited websites, and unlimited databases. You also get
                    cPanel, Softaculous (400+ applications), weekly JetBackup,
                    multiple PHP versions, and free SSL certificates—ensuring
                    top-notch security and performance.
                  </p>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="200">
                {/* <i class="bx bx-help-circle icon-help"></i>  */}
                <a
                  href
                  data-bs-toggle="collapse"
                  data-bs-target="#faq-list-2"
                  class="collapsed"
                >
                  How much NVMe storage is provided?
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>
                <div
                  id="faq-list-2"
                  class="collapse"
                  data-bs-parent=".faq-list"
                >
                  <p>
                    We provide 5GB NVMe SSD storage, which is more than
                    sufficient to host any kind of website, except for file
                    hosting services. Our high-speed NVMe ensures fast
                    performance and reliability for your website.
                  </p>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="500">
                {/* <i class="bx bx-help-circle icon-help"></i> */}
                <a
                  href
                  data-bs-toggle="collapse"
                  data-bs-target="#faq-list-5"
                  class="collapsed"
                >
                  Can I upgrade my hosting plan later?
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>
                <div
                  id="faq-list-5"
                  class="collapse"
                  data-bs-parent=".faq-list"
                >
                  <p>
                    Yes! Once we launch additional plans with more storage and
                    features, you’ll have the option to upgrade seamlessly. Stay
                    tuned for future updates!
                  </p>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="300">
                {/* <i class="bx bx-help-circle icon-help"></i>  */}
                <a
                  href
                  data-bs-toggle="collapse"
                  data-bs-target="#faq-list-3"
                  class="collapsed"
                >
                  Are the software licenses genuine?
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>
                <div
                  id="faq-list-3"
                  class="collapse"
                  data-bs-parent=".faq-list"
                >
                  <p>
                    Yes, all our software licenses are 100% original and come
                    with guaranteed activation.
                  </p>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-delay="400">
                {/* <i class="bx bx-help-circle icon-help"></i> */}
                <a
                  href
                  data-bs-toggle="collapse"
                  data-bs-target="#faq-list-4"
                  class="collapsed"
                >
                  How do I receive my purchased license key?
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>
                <div
                  id="faq-list-4"
                  class="collapse"
                  data-bs-parent=".faq-list"
                >
                  <p>
                    After purchase, the license key and activation instructions
                    will be sent to your email instantly or within a few hours.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQ;
